import React from 'react';
import { Table } from 'antd';

const CalculatorTable = ({ results, columns, pageSize, setPageSize }) => {
  return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
      <Table 
        columns={columns}
        dataSource={results} 
        pagination={{
          pageSize: pageSize,
          pageSizeOptions: ['10', '20', '50', '100'],
          showSizeChanger: true,
          onShowSizeChange: (current, size) => setPageSize(size),
        }}
        scroll={{ x: 'max-content' }}
        style={{ 
          minWidth: '100%', // Ensures the table takes full width
          overflowX: 'auto' // Allows horizontal scrolling
        }}
      />
    </div>
  );
};
export default CalculatorTable;